import * as React from "react"
import { Container } from "react-bootstrap"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Table from "../../components/table"

import useClanLocalityData from "../../hooks/useClanLocalityData"
import useClanKinshipData from "../../hooks/useClanKinshipData"

const ClanAllYear = () => {

  const localityData = useClanLocalityData()
  const kinshipData  = useClanKinshipData()

	const data = localityData.concat(kinshipData)
		.sort((a, b) => a.cchypy.localeCompare(b.cchypy))
		.reduce((prev, curr) => {
			const prevFirstLetter = prev.length > 0 ? prev[prev.length - 1].cchypy[0] : ""
			const currFirstLetter = curr.cchypy[0]

			if (prevFirstLetter !== currFirstLetter) {
				prev.push({ ccchi: currFirstLetter.toUpperCase(), isNonDataRow: true })
			}

			prev.push(curr);

			return prev;
		}, [])

  const columns = [
    { name: "Name in Chinese", key: "ccchi" },
    { name: "Name in English", key: "cceng" },
    { name: "Year Estab.", key: "yearest" },
    { name: "Type: Locality (L) or Kinship (K)", key: "type" },
    { name: "Kinship/Locality", key: "locality|kinship" },
  ]

  return (
    <Layout>
      <Seo title="Index of Chinese Clan Associations by Name" />

      <Container>
			<h1>Index of Chinese Clan Associations by Name</h1>

      <Table
        columns={columns}
        data={data}
        // paginationSize={20}
				routeLink={() => "/map"}
				routeState={({ id, type }) => ({ clanId: id, clanType: type })}
      />

      </Container>
    </Layout>
  )
}

export default ClanAllYear
